// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__2zgnx","inputDescription":"styles_inputDescription__2rLrC"};